window.addEventListener('load', () => {
  (function () {
    const burger = document.getElementById('burger-button');
    const mobileMenu = document.getElementById('mobile-menu');

    const header = burger.closest('header');

    burger.addEventListener('click', () => {
      if (header) mobileMenu.style.top = `${header.getBoundingClientRect().bottom}px`;
      burger.classList.toggle('open');
      mobileMenu.classList.toggle('-translate-x-full');

      if (burger.classList.contains('open')) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });

    // Outside menu click
    // document.addEventListener("click", (e) => {
    //   if (
    //     !mobileMenu.contains(e.target) &&
    //     !burger.contains(e.target) &&
    //     burger.classList.contains("open")
    //   ) {
    //     burger.classList.remove("open");
    //     mobileMenu.classList.add("-translate-x-full");
    //     document.body.style.overflow = "";
    //   }
    // });
  })();
});
